// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyCNztgGlpHeL104Ksz7xjUCNmSd9UDt7LM",
    authDomain: "anthonyangatia-a80e6.firebaseapp.com",
    projectId: "anthonyangatia-a80e6",
    storageBucket: "anthonyangatia-a80e6.appspot.com",
    messagingSenderId: "295881151464",
    appId: "1:295881151464:web:2a7d0ed6e3e8376a8dca5d",
    measurementId: "G-8DLRKKV2HK"
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
